export default __webpack_public_path__ + "580df17f8e8764c84f4caa7794829456.png";